export const options = {
  hasGroups: 'Opcja posiada przypisane grupy',
  hasRules: 'Opcja posiada przypisane reguły',
  hasModels: 'Opcja posiada przypisane modele 3D',
  hasPackages: 'Opcja posiada przypisane pakiety',
  assignmentsToOption: 'Przypisania dla opcji',
  optionPropertiesInfo: 'Edycja właściwości formularza',
  colorInfo: 'Kolor opcji w formularzu',
  selectedInfo: 'Czy opcja jest domyślna?',
  disabledInfo: 'Czy opcja jest wyłączona?',
  visibleInfo: 'Czy opcja jest widoczna?',
  highlightedInfo: 'Czy opcja jest wyróżniona?',
  numericMin: 'Wartość minimalna',
  numericMax: 'Wartość maksymalna',
  numericValue: 'Wartość domyślna',
  unit: 'Jednostka',
  step: 'Krok',
  savedChanges: 'Zapisano zmiany',
  integrationNotIntegrated: 'Opcja nie ma przypisanej wartości integracji.',
  integrationUnknownValue:
    'Nieznana wartość integracji - mogła ulec zmianie w Impuls.',
  integrationStepNotIntegrated:
    'Krok tej opcji nie ma kodu integracji - brak możliwości weryfikacji wartości integracji opcji.',
} as const
